// components/Hero.jsx
import React, { useState } from 'react';
import train from "../../assets/train2.png";
import Logo from "../../assets/inovact.png";
import pmi from "../../assets/pmi-premier.png";
import pmp from "../../assets/pmp1.png";
import "../CSS/LandingHero.css";
import PmicpEligibilityModal from './PmicpEligibilityModal';

const PmicpHeroSection = ({ scrollToCalendar, openEligibilityModalPmi }) => {
  const [showEligibilityModalPmi, setShowEligibilityModalPmi] = useState(false);

  const handleEligibilityCompletePmi = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModalPmi(false);

    // Rediriger vers l'inscription si recommandation PMICP
    if (results.recommendation.certification === 'PMICP') {
      scrollToCalendar();
    }
  };

  return (
    <>
      <div className="landing-hero-section">
        {/* Conteneur de la bannière */}
        <div className="landing-hero-banner">
          {/* Image de fond */}
          <img
            src={train}
            alt=""
            loading="lazy"
            className="landing-hero-image landing-hero-image-animation"
          />

          {/* Overlay */}
          <div className="landing-hero-overlay"></div>

          {/* Contenu centré */}
          <div className="landing-hero-content landing-hero-content-container">

            <div className="landing-hero-title landing-title1 ">
              <a
                href="https://www.credly.com/badges/ada65326-d394-4cf7-91a7-35956cb7a384/public_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="landing-logo-img1" src={pmi} loading="lazy" alt="Logo PMI" />
              </a>
            </div>

            {/* Titre principal */}
            <h1 className="landing-hero-title landing-hero-title-animation">
              <span className="landing-title-white">
                Pourquoi les certifiés PMI-CP™ sont l’avenir du {' '}
              </span>
              <br />
              <span className="landing-title-white">secteur de la construction ?</span>
            </h1>

            {/* Description */}
            <p className="landing-hero-description landing-hero-description-animation">
              Inscrivez-vous dès maintenant et bénéficiez d'un tarif sponsorisé.
            </p>

            {/* Boutons CTA */}
            <div className="landing-hero-buttons landing-hero-buttons-animation">
              <button
                className="landing-hero-btn landing-hero-btn-secondary"
                style={{ width: 'auto' }}
                onClick={openEligibilityModalPmi}
              >
                Vérifier votre éligibilité
              </button>
              <button
                className="landing-hero-btn landing-hero-btn-primary"
                style={{ width: 'auto' }}
                onClick={scrollToCalendar}
              >
                Voir calendrier et tarif
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal d'éligibilité */}
      <PmicpEligibilityModal
        isOpen={showEligibilityModalPmi}
        onClose={() => setShowEligibilityModalPmi(false)}
        onComplete={handleEligibilityCompletePmi}
      />
    </>
  );
};

export default PmicpHeroSection;